import type { GatsbyBrowser } from 'gatsby'

import { routeChangeEvent } from './src/lib/analytics'
import { installThemePerfDevtoolsHook } from './src/lib/themePerfDevtoolsHook'
import { installThemePerfApi } from './src/lib/themePerf'
export { wrapRootElement, wrapPageElement } from './src/wrapGatsbyElements'

// Measurement-only (GATSBY_PROFILE=1): install the fiber re-render counter at
// module load — before React initializes — so it sees every commit. No-op when
// the flag is off.
installThemePerfDevtoolsHook()

export const onClientEntry: NonNullable<
  GatsbyBrowser['onClientEntry']
> = () => {
  // Expose window.__themePerf for the perf-baseline harness. No-op when the
  // GATSBY_PROFILE flag is off.
  installThemePerfApi()
}

export const onRouteUpdate: NonNullable<GatsbyBrowser['onRouteUpdate']> = ({
  prevLocation,
}) => {
  // prevLocation is null on the initial load, where the GTM All Pages trigger
  // already fires a PageView. Only emit route-change for real client-side
  // navigations to avoid double-counting the landing pageview.
  if (prevLocation) {
    routeChangeEvent()
  }
}
